/* eslint-disable */
export default {
  removeMeetingWarning:
    '예약 기능이 중단되었습니다. 화상 모임을 예약하려면 {app} 앱을 사용하세요.',
  scheduleMeetingTips:
    '이 앱에서 모임을 제거했습니다. 모임을 사용하려면 {app} 앱을 사용하는 것이 좋습니다.',
  migrateToPluginAlert:
    '참고: 이 앱은 Outlook 버전 2016 및 이전 버전과 Internet Explorer 11에서 작동하지 않습니다. Outlook을 업그레이드하거나 Microsoft Edge로 전환하거나, {app}(으)로 전환하세요',
} as const;

// @key: @#@"removeMeetingWarning"@#@ @source: @#@"The scheduling feature is discontinued. Please use the {app} to schedule your video meetings."@#@
// @key: @#@"scheduleMeetingTips"@#@ @source: @#@"Please note that we removed meetings from this app. To use meetings, we recommend the {app}."@#@
// @key: @#@"migrateToPluginAlert"@#@ @source: @#@"Note: This app will not work with Outlook version 2016 and below and Internet Explorer 11. Please upgrade your Outlook or switch to Microsoft Edge, or alternately, switch to {app}"@#@
